import { HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  let authRequest = req;
  if (authRequest.responseType === 'json' && !authRequest.url.split('/').includes('i18n')) {
    authRequest = authRequest.clone({
      responseType: 'text',
    });
  }

  // Xử lý authRequestuest
  return next(authRequest).pipe(
    tap((response: any) => {
      if (response.body && typeof response.body === 'string') {
        response.body = JSON.parse(response.body);
      }
    }),
    catchError((error) => {
      return throwError(() => error);
    }),
  );
};
